const ABProcessTaskServiceAccountingFPYearCloseCore = require("../../../core/process/tasks/ABProcessTaskServiceAccountingFPYearCloseCore");
module.exports = class ABProcessTaskServiceAccountingFPYearClose extends (
   ABProcessTaskServiceAccountingFPYearCloseCore
) {};
